import styles from './delete-relation-product-dialog.module.scss';
import { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IRelationProduct } from '../../_models/relation-product';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DeleteRelationProductDialogProps {
  open: boolean,
  onClose: () => void,
  deleteRelationProduct: IRelationProduct,
  productName: string
}

export function DeleteRelationProductDialog(props: DeleteRelationProductDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleDeleteProduct = () => {
    makeRequest(`relationProducts/${props.deleteRelationProduct.id}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t("deleteRelatedProduct.productDeleted"), type: "success" });
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("deleteRelatedProduct.couldNotDeleteProduct"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {t("standard.product")}: {props.productName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDeleteProduct}
          className='minButtonWidth'>
          {t("standard.deleteProduct")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteRelationProductDialog;